export const ACCESS_STATUS = {
  PENDING: { label: "Ofis onayı bekleniyor", cls: "bg-amber-500/10 text-amber-700 border-amber-500/30" },
  APPROVED: { label: "Onaylandı – kod bekleniyor", cls: "bg-blue-500/10 text-blue-700 border-blue-500/30" },
  ACTIVE: { label: "Erişim açık", cls: "bg-emerald-500/10 text-emerald-700 border-emerald-500/30" },
  EXPIRED: { label: "Süresi doldu", cls: "bg-slate-100 text-slate-600 border-slate-300" },
  REJECTED: { label: "Reddedildi", cls: "bg-red-500/10 text-red-700 border-red-500/30" },
  REVOKED: { label: "Ofis iptal etti", cls: "bg-red-500/10 text-red-700 border-red-500/30" },
  CLOSED: { label: "Kapatıldı", cls: "bg-slate-100 text-slate-600 border-slate-300" },
};

export const SCOPE_LABEL = { PORTFOLIO: "Portföy kayıtları", CUSTOMER: "Müşteri kayıtları" };
